import 'core-js/stable'
import React from 'react';
import ReactDOM from 'react-dom';
import reportWebVitals from './reportWebVitals';
import * as Sentry from "@sentry/react";
import { Integrations } from "@sentry/tracing";
import axios from 'axios'
import './assets/scss/style.scss'
import App from './App';
import { ErrorBoundary } from "./components";
import { withTranslation } from "react-i18next";
import { addAxiosDefaultHeaders } from './helpers'  //to call add axios headers or remove axios headers if needed
import Mixpanel from 'mixpanel-browser';

const ErrorPage = withTranslation()(ErrorBoundary);

Sentry.init({
  dsn: process.env.REACT_APP_SENTRY_DSN,
  integrations: [new Integrations.BrowserTracing()],
  release: process.env.REACT_APP_SENTRY_RELEASE,

  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  tracesSampleRate: 0.2,
});
Mixpanel.init(process.env.REACT_APP_MIXPANEL_TOKEN || "", { debug: true, ignore_dnt: true })
addAxiosDefaultHeaders(axios);
axios.interceptors.request.use(request => {
  return request
}, error => {
  return Promise.reject(error)
})
axios.interceptors.response.use(response => {
  return response
}, error => {
  return Promise.reject(error)
})

ReactDOM.render(
  <React.StrictMode>
    <ErrorPage>
      <App />
    </ErrorPage>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
